$(window).load(function () {
  /* ---------------------------------------- */
  /* ----- >>> Retina Display --------------- */
  /* ---------------------------------------- */

  var pixelRatio = !!window.devicePixelRatio ? window.devicePixelRatio : 1;
  if (pixelRatio > 1) {
    $("img").each(function () {
      $(this).attr("src", $(this).attr("src").replace("@1x", "@2x"));
    });
  }

  if (!Modernizr.svg) {
    $('img[src*="svg"]').attr("src", function () {
      return $(this).attr("src").replace(".svg", ".png");
    });
  }
});

$(document).ready(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  /* ---------------------------------------- */
  /* ----- >>> Toggle / Switcher ------------ */
  /* ---------------------------------------- */

  $(".setMenu").click(function () {
    $(".setMenu .setIcon").toggleClass("isOpen");
    $("header nav ").slideToggle("fast");
  });

  $(".isSHR i").click(function () {
    $(this).next().slideToggle(100);
  });

  $(".isSHR ul > li:last-child > a").click(function (e) {
    console.time("time1");
    var setURL = $(this).attr("href");
    var setTemp = $("<input>");
    $("body").append(setTemp);
    setTemp.val(setURL).select();
    document.execCommand("copy");
    setTemp.remove();
    console.timeEnd("time1");
    e.preventDefault();
  });

  $(document).mouseup(function (e) {
    var isTarget = $("#isCRT");
    if (!isTarget.is(e.target) && isTarget.has(e.target).length === 0) {
      isTarget.removeClass("isOpen");
    }
  });

  if ($(window).width() < 640) {
    $('nav ul > li > a[href*="#"]').click(function (e) {
      if (!$(this).hasClass("isActive")) {
        $(".isActive").next().slideUp("fast");
        $(".isActive").removeClass("isActive");
        $(this).next().slideDown("fast").css("display", "flex");
        $(this).addClass("isActive");
      } else {
        $(this).removeClass("isActive");
        $(this).next().slideUp("fast");
      }
      e.preventDefault();
      return false;
    });
  } else {
    $('header a[href*="#"]').click(function (e) {
      isTarget = $(this).next();
      if (!$(isTarget).hasClass("isActive")) {
        $("nav .isActive").slideUp("fast").removeClass("isActive");
        $(isTarget).slideDown("fast").addClass("isActive");
      } else {
        $(isTarget).slideUp(200).removeClass("isActive");
      }
      e.preventDefault();
    });

    $("header").hover(
      function () {},
      function () {
        $("nav .isActive").slideUp("fast").removeClass("isActive");
      }
    );
  }
  $(".multilevelMenu").click(function (e) {
    $(this).next().toggle();
  });

  /* ---------------------------------------- */
  /* ----- >>> Modal ------------------------ */
  /* ---------------------------------------- */

  // var setCookies = Cookies.get('setModal');

  $(".setModal .setClose").click(function () {
    var setExpire = new Date(new Date().getTime() + 15 * 60 * 1000);
    // Cookies.set('setModal', 'isShown',{expires: setExpire});
    $(".setModal").fadeOut("fast");
  });

  /*
	if (setCookies != 'isShown') {
		$('.setModal').css('display', 'flex').show();
	} else {
		$('.setModal').hide();
	}
	*/

  /* ---------------------------------------- */

  $(".setMSG .setCLS").click(function () {
    $(this).parent().fadeOut("fast");
  });
  if ($(window).width() > 640) {
    setTimeout(function () {
      $(".setMSG").fadeIn("fast");
    }, 3000);
  }

  /* ---------------------------------------- */
  /* ----- >>> Toggle / Switcher ------------ */
  /* ---------------------------------------- */

  $(".getFilter").click(function () {
    var getText = $(".getFilter > span");
    $(".getFilter .setIcon").toggleClass("isOpen");
    getText.text(getText.text() == "Cerrar" ? "Filtrar" : "Cerrar");
    $("aside").toggleClass("isOpen");
  });

  $('a[href*="#isCRT"],  #isCRT .setClose').click(function (event) {
    $("#isCRT").toggleClass("isOpen");
    event.preventDefault();
  });

  $(".getEdit").click(function (event) {
    var setTarget = $(this).attr("href");
    $(".isOpen").slideToggle(0).removeClass("isOpen");
    $(setTarget).slideToggle(0).addClass("isOpen");
    event.preventDefault();
  });

  $(".getClose").click(function (event) {
    $(".isOpen").slideToggle(0).removeClass("isOpen");
    $("#isA00").slideToggle(0).addClass("isOpen");
    event.preventDefault();
  });

  $(".getRemove").click(function (event) {
    var setTarget = $(this).attr("href");
    $(setTarget).trigger("click");
    event.preventDefault();
  });

  /* ---------------------------------------- */
  /* ----- >>> Navigation ------------------- */
  /* ---------------------------------------- */

  /*$('.setAnchor').onePageNav({
		currentClass: 'isActive',
		changeHash: false,
		scrollSpeed: 500
	});

	/* ---------------------------------------- */
  /* ----- >>> Toggles ---------------------- */
  /* ---------------------------------------- */

  $('a[href*="#isSRC"], #isSRC .setClose').click(function (e) {
    $("#isSRC").slideToggle(100);
    e.preventDefault();
  });

  /* ---------------------------------------- */
  /* ----- >>> Slide Content ---------------- */
  /* ---------------------------------------- */

  $(".setSwiper").each(function (ID, value) {
    var getMin = $(this).data("min");
    var getMax = $(this).data("max");
    var getGap = $(this).data("gap");
    var getTouch = $(this).data("touch");
    var getSlide = $(this).data("slide");

    $(this).addClass("isS000" + ID);
    $(".setPrev", this).addClass("isP000" + ID);
    $(".setNext", this).addClass("isN000" + ID);
    $(".setDots", this).addClass("isD000" + ID);

    var setSwiper = new Swiper($(".isS000" + ID), {
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: false,
      centeredSlidesBounds: false,
      watchOverflow: true,
      observeParents: true,
      observer: true,
      allowTouchMove: getTouch,
      watchOverflow: true,
      slidesPerView: getMin,
      spaceBetween: getGap,
      wrapperClass: "setItems",
      slideClass: "setItem",
      noSwiping: getTouch,
      speed: 750,
      loop: true,
      autoplay: getSlide,
      navigation: {
        prevEl: ".isP000" + ID,
        nextEl: ".isN000" + ID,
      },
      pagination: {
        bulletActiveClass: "isActive",
        el: ".isD000" + ID,
        bulletClass: "setDot",
        clickable: true,
      },
      breakpoints: {
        640: {
          spaceBetween: getGap,
          slidesPerView: getMin,
        },
        1024: {
          slidesPerView: getMax,
          spaceBetween: getGap,
        },
      },
    });
  });

  /* ---------------------------------------- */

  var setThumbs = new Swiper(".setThumbs", {
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    spaceBetween: 16,
    slidesPerView: 4.01,
    wrapperClass: "setItems",
    slideClass: "setItem",
    speed: 350,
    breakpoints: {
      640: {
        slidesPerView: 4.01,
      },
      1024: {
        slidesPerView: 6.01,
      },
    },
  });

  var setImages = new Swiper(".setImages", {
    slidesPerView: 1,
    wrapperClass: "setItems",
    slideClass: "setItem",
    zoom: true,
    thumbs: {
      swiper: setThumbs,
    },
    pagination: {
      bulletActiveClass: "isActive",
      el: ".setDots",
      bulletClass: "setDot",
      clickable: true,
    },
  });

  /* ---------------------------------------- */
  /* ----- >>> Tabs ------------------------- */
  /* ---------------------------------------- */

  $(".setTabs > ul:nth-child(1) > li").click(function (event) {
    $(".setTabs > ul > li").removeClass("isActive");
    $(this).addClass("isActive");
    $(".setTabs > ul:nth-child(2) > li").slideUp("fast");
    $(
      ".setTabs > ul:nth-child(2) > li:nth-child(" + ($(this).index() + 1) + ")"
    ).slideDown("fast");
  });

  /* ---------------------------------------- */
  /* ----- >>> Media Accordion -------------- */
  /* ---------------------------------------- */

  $("dl > dt").on("click", function () {
    if (!$(this).hasClass("isActive")) {
      $(this).parent().children("dd").slideUp("fast");
      $("dl > dt").removeClass("isActive");
      $(this).addClass("isActive").next().slideDown("fast");
    } else {
      $(this).parent().children("dd").slideUp("fast");
      $("dl > dt").removeClass("isActive");
    }
    return false;
  });

  /* ---------------------------------------- */
  /* ----- >>> Wishlist --------------------- */
  /* ---------------------------------------- */

  getWish = JSON.parse(localStorage.getItem("isWishlist")) || [];

  /* ---------------------------------------- */

  if (getWish.length > 0) {
    for (var i = 0; i < getWish.length; i++) {
      var getItem = getWish[i];

      Shopify.getProduct(getItem, function (product) {
        var getItem = "";
        var setPrice = Shopify.formatMoney(product.price, 0);
        var setSales = Shopify.formatMoney(product.compare_at_price_min, 0);

        getItem += `		<div class="setItem">`;
        getItem += `			<div><div class="setIMGs setBRD" style="background-image: url(${product.featured_image});"></div></div>`;
        getItem += `			<div>`;
        getItem += `				<p><a href="${product.url}">${product.title}</a></p>`;
        if (product.compare_at_price_min) {
          getItem += `				<p class="setPRC"><del>${setSales}</del> ${setPrice}</p>`;
        } else {
          getItem += `				<p class="setPRC">${setPrice}</p>`;
        }

        if (product.variants.length > 1) {
          getItem += `				<p><span>${product.variants[0].title}</span></p>`;
        } else {
          getItem += `				<p>&nbsp;</p>`;
        }
        getItem += `				<div class="setQuantity isS" style="display: none;">`;
        getItem += `					<button class="setLess" type="button"></button>`;
        getItem += `					<input  class="setQty"  name="quantity" type="number" value="1" min="1" max="10" readonly="readonly"/>`;
        getItem += `					<button class="setMore" type="button"></button>`;
        getItem += `				</div>`;
        getItem += `				<a class="setButton isSmall isB" href="${product.url}"><span class="isDSK">Agregar</span><span class="isMBL">+</span></a>`;
        getItem += `				<a class="getRMV" href="#" data-id="${product.handle}"><i class="isRMV"></i></a>`;
        getItem += `			</div>`;
        getItem += `		</div>`;

        $("#isWishlist").prepend(getItem);

        $(".getRMV").click(function (e) {
          var isItems = $(this).data("id");
          allSimilarProduct = $('.setWish[data-id="' + isItems + '"]');
          getWish.splice(getWish.indexOf(isItems), 1);
          localStorage.setItem("isWishlist", JSON.stringify(getWish));
          $(this).closest(".setItem").slideUp("fast");
          $(".setTotal").text(getWish.length);
          if (getWish.length === 0) {
            loadNoResult();
          }
          e.preventDefault();
        });
      });
      $(".setWish[data-id=" + getItem + "]").addClass("isActive");
    }
  } else {
    loadNoResult();
  }

  /* ---------------------------------------- */

  $(".setWish").click(function () {
    var isItems = $(this).data("id");
    var isAdded = $.inArray(isItems, getWish) !== -1 ? true : false;
    if (isAdded) {
      window.location.href = "/pages/wishlist";
    } else {
      getWish.push(isItems);
    }
    localStorage.setItem("isWishlist", JSON.stringify(getWish));
    $(this).toggleClass("isActive");
  });

  function loadNoResult() {
    console.log("Sin Productos");
  }
});

$("a").click(function () {
  $("ul").show();
});
